import React, { Suspense } from 'react';
import { Layout, Menu, Icon, Tabs, Spin, message, Result, Modal, Badge } from 'antd';
import { connect } from 'react-redux';
import InitPage from '../../components/sjzdInit/sjzdInt'
import HeaderRight from '../../components/header/header'
import 'antd/dist/antd.css';
import './index.css';
import IframePage from '../iframe/index'
import '../../scripts/config'
import SSAS from '../../scripts/ssas'
import moment from 'moment';
import $ from '../../scripts/events'
const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;
const { TabPane } = Tabs;

let store;
let $this;
class PageIndex extends React.Component {
    constructor(props) {
        super(props);
        this.newTabIndex = 0;
        this.state = {
            opening: false,//正在打开中


            initvisable: false,
            collapsed: true,//菜单折叠状态


            mkmc: '',//应用名称
            activeKey: '',//选中的菜单key
            panes: [],//面板S
            navTabIndex: 0,//顶部菜单选中时对应的INDEX
            navTabMenu: [],//顶部菜单数据集


            leftMenu: [],//选中顶部菜单对应的左侧菜单数据集
            chooseMenu: {},//选中的左侧菜单


            openKeys: [''],//当前展开的左侧菜单的key
            theme: 'dark',//主题
            selectedKeys: [],
            defaultSelectedKeys: [],
            sjzdtitle: '业务字典初始化'
        }
        $this = this;
        store = this.props.store;
        //首页字典校验
        this.props.emitHandler('DictionariesInit', { pageName: 'index', init: true });
        setTimeout(() => {
            this.setState({ initvisable: !store.Dictionaries.indexPageSuccess });
        }, 800);
        if (!store.Dictionaries.homePageSuccess) {
            this.props.emitHandler('DictionariesInit', { pageName: 'homePage', init: true });
        }
    };
    rootSubmenuKeys = [];//需要折叠的菜单
    //改变菜单颜色
    changeTheme = value => {
        this.setState({
            theme: value ? 'dark' : 'light',
        });
    };
    //组件载入完成
    componentDidMount() {
        setTimeout(() => {
            const { store } = this.props;
            const _ywzdLastUpdateTime = localStorage.getItem('indexPageUpdateTime');//业务字典末次更新时间
            if (_ywzdLastUpdateTime && store) {
                const _ywzdgxpl = SSAS.pubXtszDqz(store, 'pub_localupdate');//获取更新频率
                let _day = _ywzdgxpl === '' || _ywzdgxpl === null || _ywzdgxpl === undefined ? 7 : parseInt(_ywzdgxpl);
                const _updatedate = moment(_ywzdLastUpdateTime).add(_day, 'days');
                if (_updatedate.isBefore(moment())) {
                    this.setState({ sjzdtitle: '业务字典定期更新' });
                    setTimeout(() => {
                        //业务字典重新下载更新
                        this.setState({ initvisable: true });
                    }, 500);

                }
            }
            else {
                localStorage.setItem('indexPageUpdateTime', moment().format('YYYYMMDD'))
            }
        }, 1000);
        this.bsxwListeners();
    }
    //#region  lyh 增加异常随访菜单页面跳转
        bsxwListeners=()=>{
            $.removeAllListeners("changeTable");
            this.eventEmitter = $.addListener('changeTable', (recored) => {
                this.setState({ bsxwData: recored });
                let _parame={key:'2020102'}
                const _letMenu=
                [{
                    "key": "2020101",
                    "title": "基础档案",
                    "icon": "book",
                    "isParent": "False",
                    "url": "hjyy/sj_hjyy_jbzl_zkb/sj_hjyy_jbzl_zkb",
                    "closable": "False"
                }, {
                    "key": "2020102",
                    "title": "病史询问",
                    "icon": "file-protect",
                    "isParent": "False",
                    "url": "hjyy/sj_hjyy_bsxwJbzl/sj_hjyy_bsxwJbzl",
                    "closable": "True"
                }, {
                    "key": "2020104",
                    "title": "评估报告",
                    "icon": "form",
                    "isParent": "False",
                    "url": "hjyy/sj_hjyy_pgbg/sj_hjyy_pgbg",
                    "closable": "True"
                }, {
                    "key": "2020105",
                    "title": "早孕随访登记",
                    "icon": "file-text",
                    "isParent": "False",
                    "url": "hjyy/sj_hjyy_zysfdj/sj_hjyy_zysfdj",
                    "closable": "True"
                }, {
                    "key": "2020106",
                    "title": "妊娠结局登记",
                    "icon": "medicine-box",
                    "isParent": "False",
                    "url": "hjyy/sj_hjyy_rsjjdj/sj_hjyy_rsjjdj",
                    "closable": "True"
                }]
                try {
                    const _mkid = store.topContainer.mkid;
                    if (this.state.opening) {
                        message.info('上个页面正在打开,请稍后点击..');
                    }
                    else {
                            this.setState({ opening: true });

                            if (this.getLeftMenuObj(_letMenu, _parame)) {
                                this.menuClickStorage('setItem', { key: _mkid, mkid: _mkid, left: _parame.key });
                                setTimeout(() => {
                                    this.tabsAdd(_parame);
                                }, 100);
                            }
                            else {
                                this.setState({ opening: false });
                            }
                    }
                }
                catch (e) {
                    message.error(e);
                    this.setState({ opening: false });
                }
            }); 
        }
    //#endregion
    //生成顶部菜单
    handlerTopMenu() {
        let dataSource = store.topContainer.Menu;
        if (dataSource !== undefined) {
            return (
                dataSource.map((menu, index) => {
                    return (<Menu.Item key={menu.key}><Icon type={menu.icon} />{menu.title}</Menu.Item>)
                })
            )
        }
    }
    //顶部菜单选中
    handlerTopMenuSelect = e => {
        //获取菜单信息
        const _mkid = store.topContainer.mkid;
        this.menuClickStorage('setItem', { key: _mkid, mkid: _mkid, top: e.key });
        store.topContainer.Menu.map((menu, index) => {
            if (menu.key === e.key) {
                this.setState({ navTabIndex: index });
                this.setState({ leftMenu: menu.children });
                if (menu.children.length > 0) {
                    setTimeout(() => {
                        this.handlerLeftMenuSelect({ key: menu.children[0].key });
                    }, 50);
                }
                return;
            }
        });
    }
    //生成左侧菜单
    handlerLeftMenu(dataSource) {
        if (dataSource.length > 0) {
            try {
                return (
                    dataSource.map((menu, index) => {
                        if (menu.children) {
                            return (
                                <SubMenu key={menu.key} title={
                                    <span>
                                        <Icon type={menu.icon} />
                                        <span>{menu.title}</span>
                                    </span>
                                }>
                                    {this.handlerLeftMenu(menu.children)}
                                </SubMenu>
                            )
                        } else {
                            return (<Menu.Item key={menu.key}><Icon type={menu.icon} /><span>{menu.title}</span></Menu.Item>)
                        }
                    })
                )
            }
            catch (e) {
                message.error(e);
            }
        }
    }
    //菜单点击
    handlerLeftMenuSelect = e => {
        try {
            const _mkid = store.topContainer.mkid;
            if (this.state.opening) {
                message.info('上个页面正在打开,请稍后点击..');
            }
            else {
                this.setState({ opening: true });
                if (this.getLeftMenuObj(this.state.leftMenu, e)) {
                    this.menuClickStorage('setItem', { key: _mkid, mkid: _mkid, left: e.key });
                    setTimeout(() => {
                        this.tabsAdd(e);
                    }, 100);
                }
                else {
                    this.setState({ opening: false });
                }
            }
        }
        catch (e) {
            message.error(e);
            this.setState({ opening: false });
        }

    }
    //左侧菜单展开
    onOpenChange = openKeys => {
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({ openKeys });
        } else {
            this.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
        }
    };
    //获取菜单对应的节点数据

    getLeftMenuObj = (menus, e) => {
        const _key = e.key;
        let access = false;
        if (_key !== '' && menus.length > 0) {
            access = this.leftMenuAccess(menus, _key);
            setTimeout(() => {
                if (!access) {
                    message.info('没有相应的操作权限,请联系管理分配权限');
                }
            }, 50);
        }
        return access;
    }
    //权限判断
    leftMenuAccess = (menus, key) => {
        let access = false;
        menus.map((menu, index) => {
            if (menu.children) {
                menu.children.map((menu, index) => {
                    if (menu.key === key && menu.url !== '') {
                        access = true;
                        this.setState({ chooseMenu: menu });
                        return;
                    }
                });
                this.leftMenuAccess(menu.children, key);
            }
            else {
                if (menu.key === key && menu.url !== '') {
                    access = true;
                    this.setState({ chooseMenu: menu });
                    return;
                }
            }
        });
        return access;
    }
    //菜单折叠
    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };
    //tabs相关操作
    tabsOnChange = activeKey => {
        this.setState({ activeKey, selectedKeys: activeKey });
    };
    //tabs操作
    tabsOnEdit = (targetKey, action) => {
        this[action](targetKey);
    };
    //新建tabs
    tabsAdd = (e) => {
        const { panes } = this.state;
        const activeKey = `navTab${e.key}`;
        let paneExsit = false;
        //判断是否已有tab
        this.state.panes.forEach((pane, i) => {
            if (pane.key === activeKey) {
                paneExsit = true;
                return;
            }
        });
        this.setState({ selectedKeys: [e.key], opening: false });
        if (paneExsit) {
            this.tabsOnChange(activeKey);
        }
        else {
            const { store } = this.props;
            let LayzPage;
            if (this.state.chooseMenu.url.indexOf('http://') > -1) {
                panes.push({ title: <span><Icon type={this.state.chooseMenu.icon}></Icon>{this.state.chooseMenu.title}</span>, content: <Suspense fallback={<Spin size="large" />}><IframePage objMenu={this.state.chooseMenu}></IframePage></Suspense>, key: activeKey, closable: true });
            }
            else {
                const _url = this.state.chooseMenu.url;
                const _closable = this.state.chooseMenu.closable === 'False' ? false : true
                try {
                    LayzPage = React.lazy(() => import(`../../pages/${_url}.js`));
                    if (LayzPage !== undefined) {
                        panes.push({ title: <span><Icon type={this.state.chooseMenu.icon}></Icon>{this.state.chooseMenu.title}</span>, content: <Suspense fallback={<Spin size="large" />} style={{ margin: '200px auto' }}><LayzPage objMenu={this.state.chooseMenu} bsxwData={this.state.bsxwData} emitHandler={this.props.emitHandler} store={store} /></Suspense>, key: activeKey, closable: false });

                    }
                }
                catch (e) {
                    panes.push({
                        title: <span><Icon type={this.state.chooseMenu.icon}></Icon>{this.state.chooseMenu.title}</span>, content: <Suspense fallback={<Spin size="large" />}><Result
                            status="404"
                            title="404"
                            subTitle="抱歉，这个页面可能已经溜走了....."
                        /></Suspense>, key: activeKey, closable: true
                    });
                }
            }
            this.setState({ panes, activeKey, opening: false });
        }
    };
    //tabs关闭
    remove = targetKey => {
        let { activeKey } = this.state;
        let lastIndex;
        this.state.panes.forEach((pane, i) => {
            if (pane.key === targetKey) {
                lastIndex = i - 1;
            }
        });
        const panes = this.state.panes.filter(pane => pane.key !== targetKey);
        if (panes.length && activeKey === targetKey) {
            if (lastIndex >= 0) {
                activeKey = panes[lastIndex].key;
            } else {
                activeKey = panes[0].key;
            }
        }
        this.setState({ panes, activeKey, selectedKeys: activeKey });
    };
    //字典初始化

    inithandleCancel() {
        if (!store.Dictionaries.indexPageSuccess) {
            message.warning('字典初始化尚未完成,请勿关闭窗口');
        }
        else {
            $this.setState({ initvisable: false });
        }
    }
    //菜单点击存储/读取
    menuClickStorage = (type, parame, fn) => {
        //parame 格式，{key:'',mkid:'',top:'',left:'',navTabIndex:''}
        const lastMenu = localStorage.getItem('lastMenu');
        if (type === 'getItem') {
            if (lastMenu !== '' && lastMenu !== null && lastMenu !== undefined) {
                const menu = JSON.parse(lastMenu);
                const _data = menu.map((item, key) => {
                    if (item.mkid === parame.mkid) {
                        return item;
                    }
                });
                fn(true, _data[0]);
            }
            else {
                fn(false, {});
            }
        }
        else {
            if (lastMenu !== '' && lastMenu !== null && lastMenu !== undefined) {
                const menu = JSON.parse(lastMenu);
                const _data = menu.map((item, key) => item.mkid === parame.mkid ?
                    Object.assign({}, item, parame) :
                    item);
                localStorage.setItem('lastMenu', JSON.stringify(_data));
            }
            else {
                localStorage.setItem('lastMenu', JSON.stringify([parame]));
            }
        }
    }
    ParentTodo = (param) => {
        if (param != null && param != undefined) {
            if (param.lx === 'DictionariesUpdate') {
                $this.setState({ initvisable: true });
            }
        }
    }
    render() {
        return (
            <div className="index-container" >
                <Layout className="index-container-layout">
                    <Sider trigger={null} collapsible collapsed={this.state.collapsed} theme={this.state.theme}>
                        <Badge count={global.constants.version} style={{ marginTop: '20px' }}><div className="index-logo" ><a><img src={global.constants.logo} alt="logo" /><h1>{this.props.store.topContainer.mkmc}</h1></a></div></Badge>
                        <Menu
                            theme={this.state.theme}
                            mode="inline"
                            onSelect={this.handlerLeftMenuSelect}
                            openKeys={this.state.openKeys}
                            onOpenChange={this.onOpenChange}
                            selectedKeys={this.state.selectedKeys}
                        >
                            {this.handlerLeftMenu(this.state.leftMenu)}
                        </Menu>
                    </Sider>
                    <Layout>
                        <Header style={{ background: '#fff', padding: 0 }}>
                            <Icon
                                className="trigger"
                                type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                                onClick={this.toggle}
                            />
                            <div style={{ width: '50%', float: 'left', marginLeft: '20px' }}>
                                <Menu
                                    theme="light"
                                    mode="horizontal"
                                    defaultSelectedKeys={this.state.defaultSelectedKeys}
                                    style={{ lineHeight: '64px' }}
                                    onSelect={this.handlerTopMenuSelect}
                                >
                                    {this.handlerTopMenu()}
                                </Menu>
                            </div>
                            <HeaderRight ParentTodo={this.ParentTodo} emitHandler={this.props.emitHandler} style={{ float: 'left' }}></HeaderRight>
                        </Header>
                        <Content className="index-container-layout-content">
                            <div style={{ width: '100%', height: '100%' }}>
                                <Tabs
                                    hideAdd={true}
                                    onChange={this.tabsOnChange}
                                    activeKey={this.state.activeKey}
                                    type="editable-card"
                                    onEdit={this.tabsOnEdit}
                                    tabBarStyle={{ margin: '0px 0px 2px 0px' }}
                                    className="index-tabs"
                                >
                                    {this.state.panes.map(pane => (
                                        <TabPane tab={pane.title} key={pane.key} closable={pane.closable === 'False' ? false : true} className="index-content">
                                            {pane.content}
                                        </TabPane>
                                    ))}
                                </Tabs>
                            </div>
                        </Content>
                    </Layout>
                </Layout>
                {/****系统字典初始化弹窗****/}
                <Modal
                    title={<div><Icon type="setting"></Icon>&nbsp;&nbsp;{store.topContainer.mkmc}{this.state.sjzdtitle}</div>}
                    closable={false}
                    visible={this.state.initvisable}
                    onOk={this.initHandleOk}
                    okText='初始化'
                    cancelText='关闭'
                    onCancel={this.inithandleCancel}
                    confirmLoading={true}
                    destroyOnClose={true}
                >
                    <InitPage onCancel={this.inithandleCancel}></InitPage>
                </Modal>
            </div>
        );
    }
}
//需要渲染什么数据


function mapStateToProps(state) {
    return {
        store: state
    }
}
//需要触发什么行为


function mapDispatchToProps(dispatch) {
    return {
        indexDispatch: (par) => dispatch(
            {
                type: par.type, data: par.data
            }
        )
    }
}
PageIndex = connect(mapStateToProps, mapDispatchToProps)(PageIndex);
export default PageIndex;